import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { sendEmailXpo } from '../data-provider/send-email-xpo';
import type { SendEmailXpoData } from '../data-provider/send-email-xpo/api';

export interface UseSendEmailXpoOptions {
  onSuccess?: (data: unknown) => void;
  onError?: (error: Error) => void;
}

export const useSendEmailXpo = (options?: UseSendEmailXpoOptions) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (data: SendEmailXpoData) => sendEmailXpo(data),
    onError: (error: Error) => {
      dispatch(setAppLoader(false));
      showNotification({
        message: 'Failed to send claim email to XPO.',
        type: NOTIFICATION_TYPES.ERROR,
      });
      options?.onError?.(error);
    },
    onMutate: () => {
      dispatch(setAppLoader(true));
    },
    onSuccess: (data) => {
      dispatch(setAppLoader(false));

      showNotification({
        message: 'Email sent to XPO carrier successfully',
        type: NOTIFICATION_TYPES.SUCCESS,
      });

      options?.onSuccess?.(data);
    },
  });
};
